module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"no-luggage":"Pas de bagages","quantity":"Quantité :","weight":"Poids :","price":"Prix :"},"en":{"no-luggage":"No luggage","quantity":"Quantity :","weight":"Weight :","price":"Price :"}}')
  delete Component.options._Ctor
}
